export const API_PATH_ApiTrafficStudyHistoryLoadGet = '/services/traffic-studies/apiTrafficStudyHistoryLoadGet';
